/**
 * 购物车
 */
class CartItems extends HTMLElement {
  constructor() {
    super();
    
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.addEventListener('change', this.debouncedOnChange.bind(this));
    updateIntegral({domId: 'integral-cart'})
  }
  
  /**
   * 绑定数量增减时的函数
   * @param event
   */
  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }
  
  /**
   * 获取动态数据
   * @returns {[{section: string, selector: string, id: string}, {section: string, selector: string, id: string}]}
   */
  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-badge',
        selector: '.tm-cart-badge'
      }
    ];
  }
  
  /**
   * 更新购物车数量
   * @param line
   * @param quantity
   * @param name
   */
  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    
    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.renderContents(parsedState);
        this.updateLiveRegions(line, parsedState.item_count);
        this.disableLoading();
        updateIntegral({
          domId: 'integral-cart',
          productList: parsedState.items
        })
      }).catch((err) => {
      console.error(err);
      document.querySelector('cart-error-message.uk-alert').show();
      document.querySelector('cart-error-message.uk-alert').setContent(window.cartStrings.error);
      this.disableLoading();
    });
  }
  
  /**
   * 更新DOM
   */
  renderContents(state) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(state.sections[section.section], section.selector);
    }));
  }
  
  // 更新数量报错信息
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItem = document.getElementById(`Line-item-error-${line}`);
      lineItem.show();
      lineItem.setContent(window.cartStrings.quantityError.replace('[quantity]', document.getElementById(`Quantity-${line}`).value))
    }
    this.currentItemCount = itemCount;
  }
  
  /**
   * 获取数据
   * @param html
   * @param selector
   * @returns {*}
   */
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  
  enableLoading(line) {
    this.querySelectorAll('loading-animation')[line - 1].show();
    document.activeElement.blur();
  }
  
  disableLoading() {
    this.querySelectorAll('loading-animation').forEach((overlay) => overlay.hide());
  }
}

customElements.define('cart-items', CartItems);

class HeaderCartDropdown extends CartItems {
  constructor() {
    super();
  }
  
  getSectionsToRender() {
    return [
      {
        id: 'cart-offcanvas-nav',
        section: 'header-cart-dropdown',
        selector: '[data-cart-content]'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-badge',
        selector: '.tm-cart-badge'
      }
    ];
  }
}

customElements.define('header-cart-dropdown', HeaderCartDropdown);

